import React from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { PopupEntryPoint } from '../shared/popup-entry-point';

import { PREMIUM_DIALOG_CONFIG, STANDARD_DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

export function PaymentDetailsPopup() {
	const { edition } = useEditionAwareness();

	return (
		<PopupEntryPoint
			entryPoint={entryPoint}
			placement={'bottom-start'}
			dialogConfig={edition === 'standard' ? STANDARD_DIALOG_CONFIG : PREMIUM_DIALOG_CONFIG}
		/>
	);
}
